import React from "react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import {
  GraphLibraryVersioningStatus,
  VersioningState,
  versioningPresentation,
} from "../../models/ClientConfiguration/VersioningState";

interface VersioningStatusChipProps {
  status: GraphLibraryVersioningStatus;
}

/**
 * Versioning state of one library, as an icon-and-text badge.
 *
 * Icon and text both carry the state so it survives being read without colour perception.
 */
const VersioningStatusChip: React.FC<VersioningStatusChipProps> = ({ status }) => {
  const { label, color, icon: Icon, description } = versioningPresentation(status);

  // Carries its own provider so the chip can be dropped anywhere, including pages that do not
  // already establish one.
  return (
    <TooltipProvider>
    <span className="inline-flex items-center gap-1">
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant={color}>
            {Icon && <Icon className="size-3" />}
            {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p>{description}</p>
          {status.versioningState === VersioningState.CheckFailed && status.failureDetail && (
            <p className="mt-1 opacity-80">{status.failureDetail}</p>
          )}
        </TooltipContent>
      </Tooltip>
    </span>
    </TooltipProvider>
  );
};

export default VersioningStatusChip;
